export default __webpack_public_path__ + "static/media/placeholder-icon.65582a57.svg";